module.exports = __webpack_public_path__ + "img/lingvo-group.313266d2.png";